import React from 'react';
import {useBundle} from '@amzn/react-arb-tools';
import {Icon, Text, useIsMobile} from '@amzn/storm-ui';
import {spinner} from '@amzn/storm-ui-icons';
import styled from 'styled-components';
import {useAccountContext} from './AccountContextProvider';
import {findFeatureLaunchInfo} from "src/components/utils";
import {WeblabedFeatures} from "src/components/Types";

const MobileTitleWrapper = styled.div`
  margin-bottom: 18px;
  & > * {
    text-align: center;
  }
`;

export const Title: React.VFC = () => {
    const [bundle, isBundleLoading] = useBundle('pages.interstitial');
    const {hasNestedAccounts} = useAccountContext();
    const isMobile = useIsMobile();

    if (isBundleLoading) {
      return <Icon type={spinner}></Icon>
    }

    let titleMessageId : string;
    let subtitleMessageId: string;
    if (hasNestedAccounts){
            titleMessageId = 'title-region-switcher-weblab-enabled';
            subtitleMessageId = 'subtitle-region-switcher-weblab-enabled'
    } else {
        titleMessageId = 'account_only_title';
        subtitleMessageId = 'account_only_subtitle'
    }
    const title = bundle.getMessage(titleMessageId);
    const subtitle = bundle.getMessage(subtitleMessageId);

    const textComponents = (
      <>
        <Text type="h2" styleAs="h4" textColor="base">{title}</Text>
        <Text textColor="secondary">{subtitle}</Text>
      </>
    );

    if (isMobile) {
      return (
        <MobileTitleWrapper>
          {textComponents}
        </MobileTitleWrapper>
      );
    }

    return textComponents;
}
